export default __webpack_public_path__ + "static/media/bumper-unaccept.e8a1b4fc.png";